import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next3';
import Prev from '../../../../static/images/icons/Prev3';
var carousel = {
  arrowBgColor: colors.pumpkinOrange,
  arrowHoverBgColor: colors.deepOrange,
  arrowForeColor: colors.white,
  arrowPrevMarginLeft: '4px',
  arrowNextMarginRight: '4px',
  highlightColor: colors.black,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.black,
  paginationBorderColor: colors.black,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.pumpkinOrange,
  heroPaginationInactiveColorVariationC: colors.pumpkinOrange,
  heroPaginationActiveColor: colors.pumpkinOrange,
  heroPaginationBorderColor: colors.deepOrange,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;